import { Button, Input, Modal } from '@farol-ds/react'
import { sendMetrics } from '@jusbrasil-web/shared-utils-events'
import { ChangeEvent, useEffect, useRef, useState } from 'react'

import { fileToBase64 } from '../../../utils'
import { useIdDocumentValidationContext } from '../context'
import { Steps } from '../enums'
import styles from './steps.module.scss'

export function DocumentPreview() {
  const { setSharedData, sharedData, setCurrentStep, eventData, viewer } =
    useIdDocumentValidationContext()
  const inputRef = useRef<HTMLInputElement>(null)
  const [previewSrc, setPreviewSrc] = useState<string | null>(null)
  const pid = viewer?.pid
  const file = sharedData.documentFile

  useEffect(() => {
    sendMetrics('UserAccount.IdValidationDocumentPreview', `${pid}`, { ...eventData })
  }, [eventData, pid])

  useEffect(() => {
    if (!file) {
      setPreviewSrc(null)
      return
    }

    const objectUrl = URL.createObjectURL(file)
    setPreviewSrc(objectUrl)

    return () => {
      URL.revokeObjectURL(objectUrl)
    }
  }, [file])

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0]
    if (!selectedFile) {
      return
    }

    fileToBase64(selectedFile).then((documentData) => {
      setSharedData({
        ...sharedData,
        documentFile: selectedFile,
        documentData,
        documentName: selectedFile.name,
      })
    })
  }

  const triggerFileInput = () => {
    inputRef?.current?.click()
  }

  const handleSubmit = () => {
    sendMetrics('UserAccount.IdValidationDocumentSubmitted', `${pid}`, { ...eventData })
    setCurrentStep(Steps.VALIDATING_DOCUMENT)
  }

  return (
    <>
      <Modal.Header>
        <Modal.HeaderTitle>A foto está boa?</Modal.HeaderTitle>
        <Modal.HeaderDescription>
          Confirme se o documento está legível e bem iluminado.
        </Modal.HeaderDescription>
      </Modal.Header>
      <Modal.Body data-testid="document-preview-step">
        <div className={styles.preview}>
          {previewSrc && (
            // eslint-disable-next-line @next/next/no-img-element
            <img src={previewSrc} alt="Documento" className={styles.previewImage} />
          )}
        </div>
        <Input
          data-testid="validate-document-input-file"
          type="file"
          ref={inputRef}
          onChange={handleFileChange}
          className={styles.previewInput}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button kind="primary" onClick={handleSubmit}>
          Sim
        </Button>
        <Button kind="tertiary" onClick={triggerFileInput}>
          Não, quero refazer
        </Button>
      </Modal.Footer>
    </>
  )
}
